// Libellé d'un mode de paiement enregistré (codes internes de la caisse et des règlements)
const LABELS = {
    liquidity: 'payment.cash',
    CASH: 'payment.cash',
    credit: 'credit.toggle',
}

const NAMES = {
    MOBILE: 'Mobile Money',
    MOMO_PAY: 'MoMo Pay',
    STRIPE: 'Carte bancaire',
    stripe: 'Carte bancaire',
    fidelity: 'Fidélité',
}

export function paymentModeLabel(mode) {
    if (!mode) return '—'
    if (LABELS[mode]) return window.i18n.global.t(LABELS[mode])
    return NAMES[mode] || mode
}
